// src/constants.ts
var PUBLIC_RPC_ENDPOINTS = {
  mainnet: "https://mainnet-archive.chainflip.io",
  perseverance: "https://archive.perseverance.chainflip.io",
  sisyphos: "https://archive.sisyphos.chainflip.io",
  backspin: "https://backspin-rpc.staging"
};
export {
  PUBLIC_RPC_ENDPOINTS
};
